import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApxControlChange } from '../../models/change.model';
import { ApxAccessibleControlDirective } from '../../utils/directives/acessible-control.directive';

let nextUniqueId = 0;

@Component({
    selector: 'apx-radio-button',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './radio-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApxRadioButtonComponent extends ApxAccessibleControlDirective {
    cdr = inject(ChangeDetectorRef);

    @Input() value!: string;
    @Input() isFirst!: boolean;
    @Input() isLast!: boolean;
    @Input() isVertical!: boolean;
    @Input() checked!: boolean;
    @Input() invalid!: boolean;
    @Input() disabled!: boolean;
    @Output() readonly changed = new EventEmitter<ApxControlChange>();

    private readonly uniqueId = nextUniqueId++;
    readonly inputId = `apx-radio-${this.uniqueId}`;
    readonly labelId = `apx-label-${this.uniqueId}`;
}
